<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb2"></question-title>

      <button
        v-for="field in question.fields"
        v-bind:key="field.choice"
        v-on:click="recordAnswer(field.choice)"
        :class="[
          'button',
          'is-fullwidth',
          'mb1',
          { 'is-primary': choice === field.choice }
        ]"
      >
        {{ field.choice }}
      </button>

      <next-button
        ref="nextButton"
        :id="question.id"
        :choice="choice"
      ></next-button>
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";

export default {
  name: "multichoice",

  mixins: [baseQuestion],

  methods: {
    recordAnswer(choice) {
      this.choice = choice;
      this.$store.dispatch("interview/setNext", true);
      this.$nextTick(() => {
        let btn = this.$refs.nextButton.$el;
        if (btn) {
          btn.click();
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  height: auto !important;
  white-space: normal;
  line-height: 2rem !important;
  padding-top: 18px;
  padding-bottom: 18px;
}
</style>
